import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

const Disclaimer = ({ disclaimer }) => {

  return (
    <section className="mr-lg-4">
      {disclaimer.map(item => {
        const sectionIndex = disclaimer.indexOf(item);
        const { section, list } = item;

        return (
          <div key={sectionIndex} data-aos="fade-up" data-aos-easing data-aos-duration="1000" data-aos-once="true">
            <p className="font-weight-bold lead mb-1">{section}</p>
            <ul className="list-unstyled">
              {
              list.map(el => {
                const elIndex = list.indexOf(el);
                return (
                  <li className="text-capitalize" key={elIndex}><small><FontAwesomeIcon className="" icon={faCheckCircle} /> {el}</small></li>
                )
              })
              }
            </ul>
          </div>
        );
      })}
    </section>
  );
}

export default Disclaimer;